// Fuente única de las rutas que pertenecen al plan Pro (el circuito + premium).
// Se usa para filtrar rutas (resolveRoutes) y items de menú (MenuSider) cuando
// el tenant es lite. Match por prefijo: cubre subrutas (ej. /admin/presupuestos/:id/documentos).
//
// ── Qué hay aquí y qué NO ────────────────────────────────────────────────────
//
// Solo se listan paths que existen como entradas reales en los archivos
// src/assets/routes/userTypes/*.routes.js. NO se agregan paths inexistentes.
//
// Features Pro que deliberadamente NO tienen path propio en esta lista:
//
//   • ODT (Orden de Trabajo): es un tab dentro de la ficha de cliente
//     (/admin/clientes/:id). No tiene ruta propia en el router; sus acciones
//     destructivas las restringe el backend según el plan del tenant.
//
//   • Trazabilidad del circuito: son tiles/widgets dentro de
//     /admin/panel-operacional (que SÍ está en la lista). Al bloquear esa
//     ruta completa, la trazabilidad queda cubierta automáticamente.
//
// Features que quedan en Lite deliberadamente:
//
//   • /admin/reportes-visita: fuera del circuito en v1; se decidió dejarlo en
//     el tier base hasta que se defina su posicionamiento comercial en v2.
//
export const PRO_ROUTES = [
  '/admin/ciclo',
  '/admin/budget',
  '/admin/presupuestos',
  '/admin/hallazgos',
  '/admin/colecciones',
  '/admin/document-composer',
];

export function isProRoute(path) {
  if (!path) return false;
  return PRO_ROUTES.some((p) => path === p || path.startsWith(`${p}/`));
}
